/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetClearanceSummaryResponseJson } from './get-clearance-summary-response-json';
import { GetClearanceSummaryResult } from '../results/get-clearance-summary-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseSummary } from './clearance-case-summary';
import { TransportType } from '../enums/transport-type.enum';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetClearanceSummaryResponse extends ResponseWithErrorGeneric<GetClearanceSummaryResponseJson, GetClearanceSummaryResult> implements IResponseWithErrorGeneric<GetClearanceSummaryResult> {
  public clearanceCase: ClearanceCaseSummary;
  public lastTransportType: TransportType;

  //<custom-body>
  constructor(response: HttpResponse<GetClearanceSummaryResponse>) {
    super(response, GetClearanceSummaryResult.Error);
    if (this.result !== GetClearanceSummaryResult.Success) return;

    this.lastTransportType = this.body.lastTransportType;
    this.clearanceCase = this.body.clearanceCase;
  }
  //</custom-body>
}
